function assert(value: any, message = "Assertion failed"): asserts value {
  if (!value) throw new Error(message);
}

export default assert;
